export const filterImpactAttributes = (key, value, initiative, workstream, subsectors) => {
  if (initiative.impact && Array.isArray(initiative.impact)) {
    const isNotSetFiltered = Array.isArray(value) && value.includes('<not set>');
    const hasNoImpact = !initiative.impact || initiative.impact.length === 0;
    if (isNotSetFiltered && hasNoImpact) {
      return true;
    }
    return initiative.impact.some((impactItem) => {
      if (key === 'frequencyAndDirection' && impactItem.frequencyAndDirection) {
        return value.includes(impactItem.frequencyAndDirection);
      }
      if (key === 'impactNumber' && impactItem.impactNumber) {
        return value.includes(impactItem.impactNumber);
      }
      if (key === 'typeOfImpact' && impactItem.typeOfImpact) {
        return value.includes(impactItem.typeOfImpact);
      }
      if (key === 'Whose P&L does this impact?' && impactItem.workstream) {
        const subworkstream = workstream.find((sub) => sub._id === impactItem.workstream);
        return value.includes(subworkstream.subworkstreamName);
      }
      if (key === 'sector' && impactItem?.subsector) {
        const subsector = subsectors.find((sub) => sub?._id === impactItem?.subsector);
        return value.includes(subsector?.sector?.sectorName || '<not set>');
      }
      if (key === 'subsector' && impactItem?.subsector) {
        const subsector = subsectors.find((sub) => sub?._id === impactItem?.subsector);
        return value.includes(subsector?.subsectorName || '<not set>');
      }
      return false;
    });
  }
  return false; // Initiative has no impact or impact is not an array
};

export const filterKPIAttributes = (key, value, initiative, subsectors) => {
  const isNotSetFiltered = Array.isArray(value) && value.includes('<not set>');
  const hasNoKPI = !initiative.KPI || initiative.KPI.length === 0;

  // If '<not set>' is one of the selected values, handle initiatives without KPI
  if (isNotSetFiltered && hasNoKPI) {
    return true;
  }

  if (initiative.KPI && Array.isArray(initiative.KPI)) {
    return initiative.KPI.some((kpiItem) => {
      if (key === 'TypeOfKPI' && kpiItem.TypeOfKPI) {
        return value.includes(kpiItem.TypeOfKPI);
      }
      if (key === 'UniversalKPI' && kpiItem.UniversalKPI) {
        return value.includes(kpiItem.UniversalKPI);
      }
      if (key === 'unitOfMeasurement' && kpiItem.unitOfMeasurement) {
        return value.includes(kpiItem.unitOfMeasurement);
      }
      if (key === 'aggregationMode' && kpiItem.aggregationMode) {
        return value.includes(kpiItem.aggregationMode);
      }
      if (key === 'kpiSector' && kpiItem?.subsector) {
        const subsector = subsectors.find((sub) => sub?._id === kpiItem?.subsector);
        return value.includes(subsector?.sector?.sectorName || '<not set>');
      }
      if (key === 'kpiSubsector') {
        const subsector = subsectors.find((sub) => sub?._id === kpiItem?.subsector);
        return value.includes(subsector?.subsectorName || '<not set>');
      }
      return false;
    });
  }

  // If '<not set>' is NOT selected, initiatives without KPI should not be included here
  return false;
};

export const filterMilestoneAttributes = (key, value, initiative) => {
  if (initiative.milestones && Array.isArray(initiative.milestones)) {
    return initiative.milestones.filter((milestoneItem) => {
      if (key === 'milestoneNumber' && milestoneItem.milestoneNumber) {
        return value === milestoneItem.milestoneNumber;
      }
      if (key === 'type' && milestoneItem.type) {
        return value === milestoneItem.type;
      }
      if (key === 'status' && milestoneItem.status) {
        return value === milestoneItem.status;
      }
      if (key === 'name' && milestoneItem.name) {
        return value === milestoneItem.name;
      }
      if (key === 'planningSummary' && milestoneItem.planningSummary) {
        return value === milestoneItem.planningSummary;
      }
      if (key === 'planningCheck' && milestoneItem.planningCheck) {
        return value === milestoneItem.planningCheck;
      }
      return false;
    });
  }
  return false; // Initiative has no milestones or milestones is not an array
};
